import { NavLink } from "react-router-dom";
import { Home, CalendarPlus, ShoppingBag, UserRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const item = "flex flex-col items-center justify-center gap-0.5 text-[10.5px] tracking-wide uppercase px-3 py-2 rounded-xl transition-colors";

export default function MobileBottomBar() {
  const { user } = useAuth();
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-sand-200 bg-white/90 backdrop-blur-xl" data-testid="mobile-bottom-bar">
      <div className="grid grid-cols-4 max-w-lg mx-auto">
        <NavLink to="/" data-testid="bbar-home" end className={({isActive})=>`${item} ${isActive?"text-sage-700":"text-sage-800/60"}`}>
          <Home className="w-5 h-5" /> Home
        </NavLink>
        <NavLink to="/book/consult" data-testid="bbar-book" className={({isActive})=>`${item} ${isActive?"text-sage-700":"text-sage-800/60"}`}>
          <CalendarPlus className="w-5 h-5" /> Book
        </NavLink>
        <NavLink to="/shop" data-testid="bbar-shop" className={({isActive})=>`${item} ${isActive?"text-sage-700":"text-sage-800/60"}`}>
          <ShoppingBag className="w-5 h-5" /> Shop
        </NavLink>
        <NavLink to={user ? "/portal" : "/login"} data-testid="bbar-account" className={({isActive})=>`${item} ${isActive?"text-sage-700":"text-sage-800/60"}`}>
          <UserRound className="w-5 h-5" /> {user ? "Portal" : "Login"}
        </NavLink>
      </div>
    </div>
  );
}
